import React from 'react';
import styled, { keyframes } from 'styled-components';
import ImpContainer from '../ImpContainer/ImpContainer';
const shimmerAnimation = keyframes `
  0%, 40% {
    visibility: hidden;
    background-position: -2500px 0; // Match the starting position
  }
  40% {
    visibility: visible;
    background-position: -2500px 0;
  }
  100% {
    background-position: 2500px 0;
  }
`;
const ShimmerContainer = styled(ImpContainer) `
  position: relative;
  height: fit-content;
  width: fit-content;
`;
const ShimmerOverlay = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-image: linear-gradient(
    135deg,
    transparent 40%,
    rgba(255, 255, 255, 0.1) 45%,
    transparent 50%,
    rgba(255, 255, 255, 0.12) 52%,
    transparent 60%
  );
  background-size: 2500px 100%;
  animation-delay: 2s;
  animation: ${shimmerAnimation} 15s linear
    ${(props) => (props.shimmerOnce ? 'forwards' : 'infinite')};
`;
export default function ImpShimmer({ children, shimmerOnce = false, }) {
    return (React.createElement(ShimmerContainer, { dataTestId: "shimmer-container" },
        children,
        React.createElement(ShimmerOverlay, { "data-test-id": "shimmer-overlay", shimmerOnce: shimmerOnce })));
}
//# sourceMappingURL=ImpShimmer.js.map